import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_NAME } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function ProductImage({
  className = ''
}: {
  className?: string;
}) {
  return <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} aria-label={`Comprar ${PRODUCT_NAME}`} className={`block rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40 ${className}`} data-id="element-47" data-mp="2lkoj6oj7qniq">
      <img src={PRODUCT_IMAGE} alt={`${PRODUCT_NAME}: 5 volúmenes y 5 bonos`} className="h-auto w-full" data-id="element-48" data-mp="2bp4ryfflgd0b" />
    </a>;
}